"use client";

import { useLayoutEffect } from "react";

function ensureTouchEventConstructor() {
  if (typeof window == "undefined") return;

  const target = window as Window & { TouchEvent?: unknown };
  if (typeof target.TouchEvent == "function") return;

  // AntV checks `event instanceof globalThis.TouchEvent`.
  // In some browsers TouchEvent constructor is missing and `instanceof` throws.
  const TouchEventStub = function TouchEventStub() {};

  try {
    (target as unknown as { TouchEvent: unknown }).TouchEvent = TouchEventStub;
    return;
  } catch {
    // Fallback for non-writable globals.
  }

  try {
    Object.defineProperty(target, "TouchEvent", {
      value: TouchEventStub,
      configurable: true,
      writable: false,
    });
  } catch {
    // Ignore: best-effort polyfill.
  }
}

ensureTouchEventConstructor();

export default function TouchEventPolyfill() {
  useLayoutEffect(() => {
    ensureTouchEventConstructor();
  }, []);

  return null;
}

